import { isAnimationComplete } from "#/game/canvasRenderer";
import { isAttackRangeFlashAnimating } from "#/game/canvasRenderer/attackRangeFlashAnim";
import { isUnmovedHighlightAnimating } from "#/game/canvasRenderer/unmovedHighlight";

import type { CanvasDrawRefs } from "./boardDrawLoopTypes";

export function nextBoardRedrawDelayMs({
  hasUnits,
  hasSmoothAnimation,
}: {
  hasUnits: boolean;
  hasSmoothAnimation: boolean;
}): number | null {
  if (!hasUnits) return null;
  if (hasSmoothAnimation) return 0;
  return null;
}

export function boardRedrawScheduleInput({
  drawRefs,
  nowMs,
}: {
  drawRefs: CanvasDrawRefs;
  nowMs: number;
}): {
  hasUnits: boolean;
  hasSmoothAnimation: boolean;
} {
  const state = drawRefs.stateRef.current;
  const viewState = drawRefs.viewStateRef.current;
  const previewAnimation = viewState.previewAnimation;
  return {
    hasUnits: state.units.length > 0,
    hasSmoothAnimation:
      drawRefs.animationRef.current !== null ||
      (previewAnimation !== null && !isAnimationComplete(previewAnimation, nowMs)) ||
      isUnmovedHighlightAnimating({
        fadeStartedAtMs: viewState.unmovedHighlightFadeStartedAtMs,
        nowMs,
      }) ||
      isAttackRangeFlashAnimating() ||
      viewState.attackRangeFlashTileKeys.length > 0,
  };
}
